<template>
    <v-row v-if="client">
        <v-col cols="12" class="name-client pb-0">
            {{ client.name }}
        </v-col>
        <v-col cols="12" class="pb-0" v-if="isStudent">
            <div class="info-client">
                {{ $t('common.objectives') }}
            </div>
            <div class="info-client-right text-truncate">
                {{ objectives }}
            </div>
            <div class="divider"/>
        </v-col>
        <v-col cols="12" class="pb-0">
            <div class="info-client">
                {{ $t('common.email') }}
            </div>
            <div class="info-client-right text-truncate">
                {{ client.email }}
            </div>
            <div class="divider"/>
        </v-col>
        <v-col cols="12" class="pb-0">
            <div class="info-client">
                {{ $t('common.phone') }}
            </div>
            <div class="info-client-right text-truncate">
                {{ phone }}
            </div>
            <div class="divider"/>
        </v-col>
        <v-col cols="12" class="pb-0">
            <div class="info-client">
                {{ $t('common.age') }}
            </div>
            <div class="info-client-right text-truncate">
                {{ age }}
            </div>
            <div class="divider"/>
        </v-col>
        <v-col cols="12" class="pb-0">
            <v-row>
                <v-col cols="12" md="6" class="py-0">
                    <div class="info-client">
                        {{ $t('common.height') }}
                    </div>
                    <div class="info-client-right text-truncate">
                        {{ height }}
                    </div>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                    <div class="info-client">
                        {{ $t('common.weight') }}
                    </div>
                    <div class="info-client-right text-truncate">
                        {{ weight }}
                    </div>
                </v-col>
            </v-row>
            <div class="divider"/>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "BasicInfoProfile",
    props: {
        client: {
            type: Object,
            default: null
        }
    },
    computed: {
        isStudent(vm = this) {
            return vm.client.accountType === 'student'
        },
        objectives(vm = this) {
            return vm.client?.objectives?.join(',') || vm.$t('common.no_set')
        },
        phoneCode(vm = this) {
            return vm.client?.country?.phoneCode || process.env.VUE_APP_COUNTRY_PHONE_CODE
        },
        phone(vm = this) {
            if(vm.client?.phone) return `${vm.phoneCode} ${vm.client.phone}`
            return vm.$t('common.no_set')
        },
        age(vm = this) {
            if(vm.client.birthDate) return vm.$moment().diff(vm.$moment(vm.client.birthDate.seconds * 1000), 'years')
            return vm.$t('common.no_set')
        },
        height(vm = this) {
            if(vm.client.height) return `${vm.client.height}cm`
            return vm.$t('common.no_set')
        },
        weight(vm = this) {
            if(vm.client.weight) return `${vm.client.weight}kg`
            return vm.$t('common.no_set')
        },
    }
}
</script>

<style scoped>

.name-client {
    font-weight: 800;
    font-size: 26px;
    line-height: 32px;
    color: #03342C;
}

.info-client {
    display: inline-block;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #333333;
    width: 30%;
}

.info-client-right {
    display: inline-block;
    font-weight: 300;
    width: 70%;
    text-align: right;
}

.divider {
    border-bottom: 2px solid #99CC00;
    margin-top: 12px;
}

</style>